import React from 'react';
import PropTypes from 'prop-types';
import { Box, List, ListItemText } from '@mui/material';
import { NavHashLink } from 'react-router-hash-link';

import { StyledNavItem } from './styles';
import Iconify from '../iconify';

HorizontalNavSection.propTypes = {
  allowedNavConfigs: PropTypes.array,
};

export default function HorizontalNavSection({ allowedNavConfigs = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ pl: 1, pr: 1, display: 'flex', flexDirection: 'row' }}>
        {allowedNavConfigs.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={NavHashLink}
      to={path}
      smooth
      sx={{
        borderRadius: 0,
        margin: '0px',
        padding: '8px 16px',
      }}
    >
      {icon && <Iconify icon={icon} />}
      <ListItemText sx={{ ml: 1 }} disableTypography primary={title} />
      {info && info}
    </StyledNavItem>
  );
}
